import React from 'react';
import { Typography, SxProps, Theme } from '@mui/material';

interface CharacterCounterProps {
  /** 現在の文字列（または文字数を直接渡したい場合は length 専用に） */
  value: string;
  /** 上限文字数 */
  max: number;
  /** 追加スタイル */
  sx?: SxProps<Theme>;
}

/**
 * 入力欄の文字数カウンター。
 * 80% 到達で警告色、100% 超で error 色＋太字。
 * メモ・ポスト・bio など、文字数上限のある入力欄全般で利用可能。
 */
const CharacterCounter: React.FC<CharacterCounterProps> = ({ value, max, sx }) => {
  const len = value.length;
  const ratio = max > 0 ? len / max : 0;
  const isOver = len > max;
  const isNear = ratio >= 0.8 && !isOver;

  return (
    <Typography
      variant="caption"
      sx={{
        color: isOver ? 'error.main' : isNear ? 'warning.main' : 'text.secondary',
        fontWeight: isOver ? 600 : 400,
        fontSize: '0.7rem',
        fontVariantNumeric: 'tabular-nums',
        ...sx,
      }}
    >
      {len.toLocaleString()} / {max.toLocaleString()}
    </Typography>
  );
};

export default CharacterCounter;
